import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';


export const displayOrders = (orders) => {
  return {
    type: actionTypes.GET_ORDERS,
    orders: orders
  }
}

export const getOrders = (token, userId) => {
  return (dispatch) => {
    if (token) {
      const queryParams = `?auth=${token}&orderBy="userId"&equalTo="${userId}"`
      axios.get(`/orders.json${queryParams}`)
        .then((response) => {
          let orders = [];
          if (response) {
            if (response.data !== null) {
              let unfilteredOrders = [];
              for (let order in response.data) {
                unfilteredOrders.push(response.data[order]);
                orders = unfilteredOrders.filter(order => order);
              }
              // 
            }
          } else {
            throw new Error('Failed to retrieve orders from database');
          }
          dispatch(displayOrders(orders));
        })
        .catch((error) => {
          console.error(error.message);
          dispatch({ type: actionTypes.DISPLAY_PAGE_ERROR });
        })
        .finally(() => {
          dispatch(toggleOrdersLoading());
        })
    }
  }
}

const addOrder = (order) => {
  return {
    type: actionTypes.ADD_ORDER,
    order: order
  }
}

const toggleOrderSending = () => {
  return {
    type: actionTypes.TOGGLE_ORDER_SENDING
  }
}

const toggleOrdersLoading = () => {
  return {
    type: actionTypes.TOGGLE_ORDERS_LOADING
  }
}

export const displayFormError = (error) => {
  return {
    type: actionTypes.DISPLAY_FORM_ERROR,
    error: error
  }
}

export const setNextID = (nextID) => {
  return {
    type: actionTypes.SET_NEXT_ID,
    nextID: nextID
  }
}

export const getNextID = (token, userId) => {
  return dispatch => {
    axios.get(`/users/${userId}/state/nextID.json?auth=${token}`)
      .then((response) => {
        if (response.data) {
          dispatch(setNextID(parseInt(response.data, 10)))
        } else {
          dispatch(setNextID(1));
        }
      })
  }
}

export const submitOrder = (orderData, token, userId) => {
  return (dispatch) => {
    orderData.userId = userId;
    dispatch(toggleOrderSending(null));
    axios.post(`/orders/.json?auth=${token}`, orderData)
      .then((response) => {
        if (response) {
          dispatch({ type: actionTypes.TOGGLE_MODAL });
          dispatch(addOrder(orderData));
          axios.put(`/users/${userId}/state/nextID.json?auth=${token}`, orderData.orderID + 1)
            .then((response) => {
              if (response) {
                dispatch(setNextID(response.data))
              } else {
                throw new Error('Failed to update ID in database');
              }
            })
            .catch((error) => {
              console.error(error.message)
            })
          axios.put(`/users/${userId}/state/ingredients.json?auth=${token}`, {
            lettuce: 0,
            bacon: 0,
            cheese: 0,
            meat: 0
          })
            .then((response) => {
              if (!response) {
                throw new Error('failed to update ingredients in Firebase');
              }
            })
            .catch((error) => {
              console.error(error.message);
            })
        } else {
          throw new Error('Connection error.  The server did not accept your submission.')
        }
      })
      .catch((error) => {
        console.error(error.message);
        dispatch(displayFormError(error.message))
      })
      .finally(() => {
        dispatch(toggleOrderSending());
      })
  }
}




// WEBPACK FOOTER //
// ./src/store/actions/ordersActions.jsx